import React, { useState, useEffect } from 'react';
import { useSurvey } from '@/hooks/useSurvey';
import { Modal } from '@/components/custom/modal/modal';
import SurveyAnswer from '@/components/custom/survey/SurveyAnswer';
// import MyProgressWidget from './MyProgressWidget';
import { WarningWallSlider, WarningWall } from '@/components/custom/warning-wall';
import { useClient } from 'jsonapi-react';
import { Loader } from '@/components/custom/loader';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';
import { useSession } from '@/hooks/useSession';
import toast from 'react-hot-toast';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';
import { DashboardStudentFeed } from './dashboard-student-feed';
import { DashboardHomeHeroB } from './home/dashboard-home-hero-b';
import { isPlayfulTheme } from '@/lib/layout-version';

export function DashboardStudent() {
  const client = useClient();
  const { getStudentSurvey, currentStudentSurvey } = useSurvey();
  const { session } = useSession();
  const [alerts, setAlerts] = useState([]);
  const [lastStudyPlan, setLastStudyPlan] = useState();
  const [banners, setBanners] = useState();
  const [loading, setLoading] = useState(true);
  const [showSurvey, setShowSurvey] = useState();
  const [lastChallenge, setLastChallenge] = useState();
  const [liveClassroom, setLiveClassroom] = useState();
  const [lastCourseWatched, setLastCourseWatched] = useState(null);
  const { abilities } = usePlatformAbilities();
  const isVersionB = isPlayfulTheme();

  const fetchData = () => {
    setLoading(true);
    const fetchBanners = client.fetch(`/bulletin_boards/active`);
    const fetchAlerts = client.fetch(`/dashboards/alerts`);
    const fetchCourse = client.fetch(`/courses/latest`);

    let promises = [fetchBanners, fetchAlerts, fetchCourse];

    promises = [
      ...promises,
      ...(abilities?.['desafio-da-semana'] ? [client.fetch(`/challenges/latest`)] : []),
      ...(abilities?.['aulas-ao-vivo'] ? [client.fetch(`/live_classrooms/next`)] : []),
      ...(abilities?.['plano-de-aula'] && !isVersionB ? [client.fetch(`/study_plan_videos/current`)] : [])
    ];

    Promise.allSettled(promises).then(([bannersResponse, alertsResponse, courseResponse, challengeResponse, liveResponse, studyPlanResponse]) => {
      if (bannersResponse?.value?.error) {
        if (bannersResponse.value.error?.status !== '401') {
          toast.error('Erro ao buscar banners');
        }
      } else {
        setBanners(bannersResponse?.value?.data);
      }
      if (alertsResponse?.value?.error) {
        toast.error('Erro ao buscar alertas');
      } else {
        setAlerts(alertsResponse?.value?.data?.data);
      }
      if (courseResponse?.value?.error) {
        toast.error('Erro ao buscar último curso acessado');
      } else {
        setLastCourseWatched(courseResponse?.value?.data);
      }
      if (abilities?.['desafio-da-semana'] && challengeResponse?.value?.error) {
        toast.error('Erro ao buscar desafio');
      } else {
        setLastChallenge(challengeResponse?.value?.data);
      }
      if (abilities?.['aulas-ao-vivo'] && liveResponse?.value?.error) {
        toast.error('Erro ao buscar aula ao vivo');
      } else {
        setLiveClassroom(liveResponse?.value?.data);
      }
      if (abilities?.['plano-de-aula'] && studyPlanResponse?.value?.error) {
        toast.error('Erro ao buscar guia de estudo');
      } else {
        const message = 'No study plan videos available for today';
        if (studyPlanResponse?.value?.message && studyPlanResponse?.value?.message === message) {
          setLastStudyPlan(null);
        } else {
          setLastStudyPlan(studyPlanResponse?.value?.data);
        }
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    if (abilities) {
      fetchData();
    }
  }, [abilities]);

  const onCloseSurvey = () => {
    setShowSurvey(false);
    getStudentSurvey();
  };

  const breadCrumbs = {
    title: 'Início',
    nav: [
      {
        route: '/',
        name: `Olá, ${session?.user?.name}`,
        isActive: true
      }
    ]
  };

  const dataCourse = {
    id: lastCourseWatched?.['course_id'],
    title: lastCourseWatched?.['course_title'],
    'finished-learning-system-items': lastCourseWatched?.['finished_items_count'],
    'learning-system-item-count': lastCourseWatched?.['total_items_count'],
    progress: lastCourseWatched?.['course_percent'],
    image: { url: lastCourseWatched?.image?.url }
  };

  return (
    <>
      <Breadcrumbs data={breadCrumbs} />

      {loading ? (
        <Loader />
      ) : isVersionB ? (
        <DashboardHomeHeroB videoId={banners?.[0]?.['video-id']} />
      ) : banners?.length > 1 ? (
        <WarningWallSlider data={banners} />
      ) : (
        <WarningWall
          warning={banners?.[0]}
          key={banners?.[0]?.id}
        />
      )}

      <DashboardStudentFeed
        loading={loading}
        alerts={alerts}
        lastStudyPlan={lastStudyPlan}
        lastChallenge={lastChallenge}
        liveClassroom={liveClassroom}
        lastCourseWatched={lastCourseWatched}
        dataCourse={dataCourse}
        currentStudentSurvey={currentStudentSurvey}
        onOpenSurvey={() => setShowSurvey(true)}
        hideEmptyState={isVersionB}
      />

      {/* <MyProgressWidget /> */}

      <Modal
        show={showSurvey}
        onClose={() => setShowSurvey(false)}
        contentClassName="modal__content--p-md"
      >
        {currentStudentSurvey && (
          <SurveyAnswer
            studentSurvey={currentStudentSurvey}
            onClose={onCloseSurvey}
          />
        )}
      </Modal>
    </>
  );
}
